import type { Language } from '../types';

export const SUPPORTED_LANGUAGES = ['en', 'ru'] as const;
export const FALLBACK_LANGUAGE = 'en';

export const LANGUAGE_TO_COUNTRY: Record<Language, string> = {
  en: 'gb',
  ru: 'ru',
};
